import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Creator from './components/Creator/Creator';
import HowToPlay from './components/HowToPlay/HowToPlay';
import GetTheGame from './components/GetTheGame/GetTheGame';
import Footer from './components/Footer/Footer';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <div className="app">
      <Header />
      <main className="app__main">
        <Hero />
        <About />
        <Creator />
        <HowToPlay />
        <GetTheGame />
      </main>
      <Footer />
    </div>
  );
}

export default App;